export const personasStyles = {
  mainComponent: {
    height: '70vh',
  },
};
